<template>
    <focus-trap
        v-model:active="activePopup"
        :initial-focus="() =>  $refs.btnLangSelector"
    >
    <div class="mec-language-selector" :class="{
            'mec-language-selector--active': activePopup
        }">
            <button type="button"
                ref="btnLangSelector"
                @click.prevent="activePopup ? closePopup() : openPopup()"
                @keydown.esc.prevent="closePopup()"
                :aria-expanded="activePopup ? 'true' : 'false'"
                class="mec-language-selector__button"
                aria-label="Languages"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" fill="none" class="header__mobile-btn--icon--lang">
                    <path fill="#333" d="M9 .432a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm2.022 16.532c.668-1.064 1.186-2.642 1.46-4.504h3.706a7.83 7.83 0 0 1-5.166 4.504Zm-9.2-4.504h3.696c.274 1.862.8 3.44 1.46 4.504a7.832 7.832 0 0 1-5.166-4.504h.01ZM6.988 1.9c-.6.96-1.084 2.338-1.372 3.966h-3.55A7.832 7.832 0 0 1 6.978 1.9h.01Zm8.946 3.966H12.4c-.288-1.628-.77-3-1.372-3.966a7.833 7.833 0 0 1 4.906 3.966ZM9 17.232c-.35 0-.97-.6-1.504-1.892a12.981 12.981 0 0 1-.76-2.88h4.528a12.982 12.982 0 0 1-.76 2.88C9.97 16.632 9.35 17.232 9 17.232Zm0-15.6c.35 0 .97.6 1.504 1.892.3.757.523 1.542.668 2.342H6.828c.145-.8.368-1.585.668-2.342C8.03 2.232 8.65 1.632 9 1.632Zm-2.496 7.8c0-.79.046-1.58.14-2.366h4.712a19.84 19.84 0 0 1 .056 4.194H6.588a20.312 20.312 0 0 1-.084-1.828ZM5.38 11.26H1.418a7.782 7.782 0 0 1 .15-4.2h3.866a21.691 21.691 0 0 0-.054 4.2Zm7.186-4.2h3.866a7.781 7.781 0 0 1 .15 4.2H12.62c.05-.6.076-1.2.076-1.828 0-.79-.043-1.58-.13-2.366V7.06Z"/>
                </svg>
                <span class="mec-language-selector__button-text-wrapper">
                    <span class="mec-language-selector__button-text">Languages</span>
                </span>
                <span class="mec-language-selector__button--icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="7" aria-hidden="true" class="icon">
                        <path
                            fill="#231F20"
                            fill-rule="nonzero"
                            d="M0 1.321 1.297 0l4.205 4.358L9.703 0 11 1.321 5.502 7z"
                            class="icon icon__fill<% if $LinkingMode == 'current' %> icon--current<% end_if %>"
                        />
                    </svg>
                </span>
            </button>

            <div class="mec-language-selector__overlay"
                 v-show="activePopup"
                 :aria-hidden="!activePopup" v-cloak></div>

            <div class="mec-language-selector__popup-wrapper" v-cloak>
                <div class="mec-language-selector__popup"
                     @keydown.esc.prevent="closePopup()"
                     :open="activePopup"
                     v-show="activePopup"
                     :aria-hidden="!activePopup"
                >
                    <div class="mec-language-selector__internal-wrapper">
                        <button type="button"
                            class="mec-language-selector__close-button"
                            @click.prevent="activePopup ? closePopup() : openPopup()"
                            @keydown.esc.prevent="closePopup()"
                            :aria-expanded="activePopup ? 'true' : 'false'"
                            aria-label="Languages"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="12"
                                fill="none"
                                class="header__mobile-btn--icon--lang"
                            >
                                <path
                                    fill="#565656"
                                    fill-rule="evenodd"
                                    d="M6 7.487 1.487 12 0 10.513 4.513 6 0 1.487 1.487 0 6 4.513 10.513 0 12 1.487 7.487 6 12 10.513 10.513 12 6 7.487Z"
                                    clip-rule="evenodd"
                                />
                            </svg>
                        </button>
                        <slot></slot>
                    </div>
                </div>
        </div>
    </div>
    </focus-trap>
</template>

<script>
import { FocusTrap } from 'focus-trap-vue';

export default {
    name: 'language-selector',
    components: {
        'focus-trap': FocusTrap,
    },
    data() {
        return {
            activePopup: false,
        };
    },
    methods: {
        openPopup() {
            this.activePopup = true;

            this.setBodyOverflowState();

            // Focus heading element on open
            this.$nextTick(() => {
                const mecLangSelectorHeader = '.mec-language-selector__header--languages';
                const languageHeader = document.querySelector(mecLangSelectorHeader);
                languageHeader.focus();
            });
        },
        closePopup() {
            this.activePopup = false;

            const langSelectorButtonClass = '.mec-language-selector__button';
            const langSelectorButton = document.querySelector(langSelectorButtonClass);
            langSelectorButton.focus();

            this.setBodyOverflowState();
        },
        /**
         * Fit the modal nicely into the viewport
         */
        setBodyOverflowState() {
            const bodyElement = document.querySelector('body');

            if (this.activePopup) {
                bodyElement.classList.add('overflow-hidden');
                return;
            }

            if (bodyElement.classList.contains('overflow-hidden')) {
                bodyElement.classList.remove('overflow-hidden');
            }
        },
    },
};
</script>
